/* Product gallery: keep the vertical thumbnail column exactly as tall as the main image. */
(function () {
  function sync(gallery) {
    var list = gallery.querySelector('slider-component .product__media-list');
    if (!list) return;
    var height = list.getBoundingClientRect().height;
    if (height > 0) gallery.style.setProperty('--jb-gallery-h', height.toFixed(2) + 'px');
  }

  function watch(gallery) {
    if (gallery.dataset.jbGalleryWatched) return;
    gallery.dataset.jbGalleryWatched = 'true';
    var list = gallery.querySelector('slider-component .product__media-list');
    sync(gallery);
    if (list && window.ResizeObserver) {
      new ResizeObserver(function () { sync(gallery); }).observe(list);
    }
    var resync = function () { sync(gallery); };
    gallery.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', resync, { once: true });
    });
    gallery.addEventListener('load', resync, true);
    window.addEventListener('resize', resync);
    window.addEventListener('load', resync);
  }

  function init() {
    document.querySelectorAll('.product--thumbnail media-gallery').forEach(watch);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
